"use client";

import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuLink,
} from "./ui/navigation-menu";

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const components: { title: string; href: string }[] = [
    { title: "Home", href: "/" },
    { title: "Services", href: "/services" },
    { title: "Our Doctors", href: "/doctors" },
    { title: "About", href: "/about" },
  ];

  return (
    <header className="bg-[#F5F5DC] opacity-97 shadow-md border-b sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between py-3 px-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <div className="flex-shrink-0 ml-4 sm:ml-0">
          <Link href="/" className="flex items-center">
            <div className="relative w-32 h-8 sm:w-40 sm:h-10 md:w-48 md:h-12">
              <Image
                src={"/foundation32-logo.png"}
                alt="Foundation32 Logo"
                fill
                className="object-contain"
                priority
                unoptimized
              />
            </div>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex flex-1 justify-center">
          <NavigationMenu>
            <NavigationMenuList className="flex gap-4 lg:gap-24">
              {components.map((comp, index) => (
                <NavigationMenuItem key={index}>
                  <NavigationMenuLink asChild>
                    <Link
                      href={comp.href}
                      className="px-3 py-2 rounded-md text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors font-semibold text-sm lg:text-base whitespace-nowrap"
                    >
                      {comp.title}
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
          </NavigationMenu>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 mr-2 md:mr-0 rounded-md text-gray-700 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-200"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isMobileMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Navigation Menu - Absolutely positioned */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
          <div className="container mx-auto px-4 py-2">
            <nav className="flex flex-col space-y-1">
              {components.map((comp, index) => (
                <Link
                  key={index}
                  href={comp.href}
                  className="px-4 py-1 rounded-md text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors font-semibold border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {comp.title}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
